var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"skc-detail"},[_c('div',{staticClass:"brand"},[_c('div',{staticClass:"name"},[_vm._v(_vm._s(_vm.brandInfo.brandEnName || '未知款式'))]),_c('div',{staticClass:"detail"},[_vm._v(_vm._s(_vm.brandInfo.productName))])])])}
var staticRenderFns = []

export { render, staticRenderFns }